// extracted by mini-css-extract-plugin
export default {"uploadContainer":"rTx4H","chooseFile":"i087j"};